import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ConditionInfo, ModalInfo } from '../../../../shared/models';
import { CustomTooltipDirective } from 'src/app/shared/directives/custom-tooltip/custom-tooltip.directive';

@Component({
  selector: 'app-modal-head',
  templateUrl: './modal-head.component.html',
  styleUrls: ['./modal-head.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, CustomTooltipDirective],
})
export class ModalHeadComponent {
  @Input() info: ModalInfo;
  @Input() loadingInfo: ConditionInfo = { condition: false };

  @Input() titleContent: TemplateRef<ElementRef>;
  @Input() textContent: TemplateRef<ElementRef>;
  @Input() contentOnHeader: TemplateRef<ElementRef>;

  @Output() closeModal = new EventEmitter<any>();

  clickCloseModal(data: any = null): void {
    this.closeModal.emit(data);
  }
}
